import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { FaPrint } from 'react-icons/fa';

const Receipt = () => {
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { state } = location;
    if (!state || !state.selectedGoods) {
      navigate('/pos');
      return;
    }

    const { paymentId, selectedGoods, totalAmount, operatorName, branchName, shiftId, companyName } = state;
    const transactionData = {
      shiftId: paymentId,
      selectedGoods,
      totalAmount,
      transactionDate: new Date().toISOString(),
      username: operatorName,
      branchName: branchName,
      shiftId: shiftId,
      companyName: companyName,
    };

    setTransaction(transactionData);
    setLoading(false);
  }, [location, navigate]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="loading-spinner">
        <div className="spinner"></div>
        <p>Loading receipt...</p>
      </div>
    );
  }

  if (!transaction) {
    return (
      <div className="error-container">
        <h2>No receipt data found</h2>
        <button onClick={() => navigate('/pos')} className="btn btn-primary">
          Return to POS
        </button>
      </div>
    );
  }

  return (
    <div className="receipt-container">
      <style>
        {`
          @media print {
            .no-print {
              display: none !important;
            }
            .receipt-content {
              padding: 0;
              box-shadow: none;
            }
          }

          .receipt-container {
            max-width: 800px;
            margin: 2rem auto;
            padding: 1rem;
          }

          .receipt-content {
            background: white;
            padding: 2rem;
            border-radius: 10px;
            box-shadow: 0 0 20px rgba(0,0,0,0.1);
          }

          .receipt-header {
            text-align: left; /* Left align */
            border-bottom: 2px solid #eee;
            padding-bottom: 1rem;
            margin-bottom: 2rem;
          }

          .receipt-table {
            width: 100%;
            border-collapse: collapse;
            margin: 1rem 0;
          }

          .receipt-table th,
          .receipt-table td {
            padding: 0.5rem;
            border-bottom: 1px solid #eee;
            text-align: left;
          }

          .receipt-footer {
            text-align: center;
            margin-top: 2rem;
            padding-top: 1rem;
            border-top: 2px solid #eee;
          }

          .action-buttons {
            display: flex;
            gap: 1rem;
            justify-content: center;
            margin-bottom: 1rem;
          }

          .btn {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.5rem 1rem;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            transition: all 0.3s ease;
            background-color: purple; /* Button color */
            color: white;
          }

          .btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 2px 5px rgba(0,0,0,0.2);
          }

          .qr-code {
            text-align: center;
            margin-top: 1rem;
          }
        `}
      </style>

      <div className="action-buttons no-print">
        <button onClick={() => navigate('/pos')} className="btn">
          <FaPrint /> Back to POS
        </button>
      </div>

      <div className="receipt-content">
        <div className="receipt-header">
          <h1>{transaction.companyName}</h1> {/* Company Name */}
          <p>Branch: {transaction.branchName || "Main Branch"}</p>
          <p>Shift ID: {transaction.shiftId}</p> {/* Shift ID */}
          <p>Transaction ID: {transaction.shiftId}</p>
          <p>Date: {formatDate(transaction.transactionDate)}</p>
          <p>Cashier: {transaction.username}</p>
        </div>

        <table className="receipt-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {transaction.selectedGoods.map((item, index) => (
              <tr key={index}>
                <td>{item.product_name}</td>
                <td>{item.quantity}</td>
                <td>{transaction.currency} {item.selling_price.toFixed(2)}</td>
                <td>{transaction.currency} {(item.quantity * item.selling_price).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="receipt-footer">
          <p>Thank you for your business!</p>
          <p>Please keep this receipt for your records</p>
          <div className="qr-code">
            <QRCodeSVG 
              value={JSON.stringify({
                receiptId: transaction.shiftId,
                date: transaction.transactionDate,
                amount: transaction.totalAmount
              })} 
              size={128}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Receipt;